import * as types from "../constants/actionTypes";
import { RX, EPIC, RXEPIC } from "../constants/textConstants";


export const commonReducerInitialState = {
    hideBannerOnCrash: false,
    stayOnIncompleteForm: false,
    rxDown: window.serverData && window.serverData.data ? window.serverData.data.rxDown : false,
    aalDown: window.serverData && window.serverData.data ? window.serverData.data.aalDown : false,
    swhpDown: window.serverData && window.serverData.data ? window.serverData.data.swhpDown : false,
    epicEHRDown: window.serverData && window.serverData.data ? window.serverData.data.epicEHRDown : false,
    screenBreakPoint: ''
};

function getProxyData(type, data, request) {
    let rtnData = data;
    if (type === types.REQUEST_PROXY_INFO) {
        if (request && request.proxySource && request.proxySource.toLowerCase() === RXEPIC) {
            rtnData = { EpicProxyInformation: [], PharmacyProxyInformation: [] };
            let epicWhoCanManageYou = data && data.WhoCanManageYou && data.WhoCanManageYou.filter(wcmy => wcmy.ProxySource.toLowerCase() === EPIC);
            let epicWhoYouCanManage = data && data.WhoYouCanManage && data.WhoYouCanManage.filter(wcmy => wcmy.ProxySource.toLowerCase() === EPIC);
            let rxWhoCanManageYou = data && data.WhoCanManageYou && data.WhoCanManageYou.filter(wcmy => wcmy.ProxySource.toLowerCase() === RX);
            let rxWhoYouCanManage = data && data.WhoYouCanManage && data.WhoYouCanManage.filter(wcmy => wcmy.ProxySource.toLowerCase() === RX);
            rtnData.EpicProxyInformation.WhoCanManageYou = epicWhoCanManageYou;
            rtnData.EpicProxyInformation.WhoYouCanManage = epicWhoYouCanManage;
            rtnData.PharmacyProxyInformation.WhoCanManageYou = rxWhoCanManageYou;
            rtnData.PharmacyProxyInformation.WhoYouCanManage = rxWhoYouCanManage;
        }
    }
    else if (type === types.PROXY_RELATIONSHIP_TYPES) {
        rtnData["Minor"] = data && data["Minor"].map(item => { return { ...item, label: item.RelationshipName }; });
        rtnData["Adult"] = data && data["Adult"].map(item => { return { ...item, label: item.RelationshipName }; });
    }
    return rtnData;
}

function getFallbackRelationTypes() {
    return {
        "Minor": [
            {
                "IsRx": false,
                "label": "Parent/Guardian of Child",
                "RelationshipCode": "3-PC",
                "RelationshipName": "Parent/Guardian of Child"
            },
            {
                "IsRx": false,
                "label": "Step-Parent",
                "RelationshipCode": "3-PC",
                "RelationshipName": "Step-Parent"
            },
            {
                "IsRx": false,
                "label": "Foster Parent",
                "RelationshipCode": "3-PC",
                "RelationshipName": "Foster Parent"
            },
            {
                "IsRx": false,
                "label": "Grandparent",
                "RelationshipCode": "3-PC",
                "RelationshipName": "Grandparent"
            },
            {
                "IsRx": false,
                "label": "Other",
                "RelationshipCode": "4-OR",
                "RelationshipName": "Other"
            }
        ],
        "Adult": [
            {
                "IsRx": true,
                "label": "Spouse/Partner",
                "RelationshipCode": "1-SP",
                "RelationshipName": "Spouse/Partner"
            },
            {
                "IsRx": true,
                "label": "Child",
                "RelationshipCode": "2-CP",
                "RelationshipName": "Child"
            },
            {
                "IsRx": true,
                "label": "Parent/Guardian",
                "RelationshipCode": "3-PC",
                "RelationshipName": "Parent/Guardian"
            },
            {
                "IsRx": true,
                "label": "Other",
                "RelationshipCode": "4-OR",
                "RelationshipName": "Other"
            }
        ]
    };
}

export default function commonReducer(state = commonReducerInitialState, action) {
    const type = action.type;

    if (typeof type === 'string') {
        if (type === types.STAY_ON_INCOMPLETE_FORM) {
            return { ...state, stayOnIncompleteForm: action.stay };
        }
        else if (type === types.USER_TO_SWITCH) {
            return { ...state, userToSwitch: action.user };
        }
        else if (type.indexOf('pharmacyProxy') === 0 || type === types.PHARMACY_NOTIFICATION_PREFERENCE_SAVE || type.indexOf('REQUEST_PROXY') === 0
            || type.indexOf('mychartProxy') === 0 || type.indexOf('healthRecordProxy') === 0 || type.indexOf('hrp_proxyRequestData') === 0
            || type === types.GENERAL_NOTIFICATION_PREFERENCE_SAVE|| type === types.CARE_COACH_NOTIFICATION_PREFERENCE_SAVE || type === types.GET_USER_NOTIFICATION_PREFERENCE || type === types.PROXY_RELATIONSHIP_TYPES
            || type === types.INITIATE_PROXY_RX_REQUEST || type === types.INITIATE_PROXY_EPIC_REQUEST || type === types.INITIATE_PROXY_EPIC_GRANT || type === types.INITIATE_PROXY_RX_GRANT || type.indexOf('PROXY_STATUS') === 0 || type === types.PROXY_TERMS_AND_CONDITIONS || type === types.ACCEPT_PROXY_TERMS_AND_CONDITIONS || type === types.VERIFY_REQUESTOR_DOB || type.indexOf(types.PROXY_DETAILS) === 0) {
            if (action.success) {
                state[type] = { ...state[type], waiting: false, success: true, response: getProxyData(type, action.data, state[type] && state[type].request), error: null, errorMessage: null };
            }
            else if (action.failure) {
                state[type] = { ...state[type], waiting: false, success: false, response: (type === types.PROXY_RELATIONSHIP_TYPES) ? getFallbackRelationTypes() : null, error: action.error, errorMessage: null };
            } else if (action.pData) {
                state[type] = { ...state[type], pData: action.pData };
            }
            else {
                state[type] = {
                    waiting: true, success: false, request: action.data,
                    response: (type === types.REQUEST_PROXY_INFO && action && action.changeProxyStatus && state[type] && state[type].response) ? state[type].response : (type === types.PROXY_RELATIONSHIP_TYPES) ? getFallbackRelationTypes() : null, error: null, errorMessage: null
                };//making response and error null as it is still waiting for response. Exceptional for proxy info response.
            }
        }
        else if (type.indexOf('GOT_APP_UPDATE') === 0) {
            if (action.success) {
                state[type] = { ...state[type], waiting: false, success: true, response: action.data, error: null };
            }
            else if (action.failure) {
                state[type] = { ...state[type], waiting: false, success: false, response: null, error: action.error };
            }
            else {
                state[type] = { waiting: true, request: action.data };
            }

            if (action.data !== undefined) {
                return { ...state, rxDown: action.data.rxDown, aalDown: action.data.aalDown, swhpDown: action.data.swhpDown, epicEHRDown: action.data.epicEHRDown };
            }
        }

        if (type === types.UPDATE_MENU) {
            return { ...state, currentLocation: action.currentLocation };
        }
        if (type === types.HIDE_BANNER_ON_CRASH) {
            return { ...state, hideBannerOnCrash: action.value };
        }
        if (type === types.SET_PROXY_MESSAGE) {
            return { ...state, actionType: action.data.actionType };
        }
        if (type === types.CLEAR_PROXY_MESSAGE) {
            return { ...state, actionType: null };
        }

        if (type === types.INITIATE_PROXY_RX_REQUEST_FAILURE) {
            state[types.INITIATE_PROXY_RX_REQUEST] = { ...state[types.INITIATE_PROXY_RX_REQUEST], waiting: false, success: false, response: null, error: action.errorCode, errorMessage: action.errorMessage };
        }

        if (type === types.VERIFY_REQUESTOR_DOB_FAILURE) {
            state[types.VERIFY_REQUESTOR_DOB] = { ...state[types.VERIFY_REQUESTOR_DOB], waiting: false, success: false, response: null, error: action.error };
        }

        if (type === types.PROXY_TERMS_AND_CONDITIONS_FAILURE) {
            state[types.PROXY_TERMS_AND_CONDITIONS] = { ...state[types.PROXY_TERMS_AND_CONDITIONS], waiting: false, success: false, response: null, error: action.error };
        }

        if (type === types.ACCEPT_PROXY_TERMS_AND_CONDITIONS_FAILURE) {
            state[types.ACCEPT_PROXY_TERMS_AND_CONDITIONS] = { ...state[types.PROXY_TERMS_AND_CONDITIONS], waiting: false, success: false, response: null, error: action.error };
        }

        if (type === types.SET_EMAIL_APPROVED_PROXY_REQUEST) {
            return { ...state, actiontype: action.data.actionType, emailProxyRequestId: action.data.emailProxyRequestId, emailProxyRequestStatus: action.data.status, emailProxyRequestErrMsg: action.data.errorMessage };
        }

        if (type === types.CLEAR_EMAIL_PROXY_MESSAGE) {
            return { ...state, actionType: null, emailProxyRequestId: null, emailProxyRequestStatus: null, emailProxyRequestErrMsg: null };
        }

        if (type === types.LOGOUT_COMPLETED) {
            state[types.REQUEST_PROXY_INFO] = {
                waiting: false, success: false, request: null,
                response: null, error: null, errorMessage: null
            };
            state[types.PROXY_REQUEST_DATA] = {};
        }

        if (type === types.INITIATE_PROXY_EPIC_GRANT_FAILURE) {
            state[types.INITIATE_PROXY_EPIC_GRANT] = { ...state[types.INITIATE_PROXY_EPIC_GRANT], waiting: false, success: false, response: null, error: action.errorCode, errorMessage: action.errorMessage };
        }

        //if (type === types.INITIATE_PROXY_RX_GRANT_FAILURE) {
        //    state[types.INITIATE_PROXY_RX_GRANT] = { ...state[types.INITIATE_PROXY_RX_GRANT], waiting: false, success: false, response: null, error: action.errorCode, errorMessage: action.errorMessage };
        //}

        if (type === types.CLEAR_REQUEST_PROXY_CHANGE_STATUS_ERROR) {
            state[types.REQUEST_PROXY_CHANGE_STATUS] = { ...state[types.REQUEST_PROXY_CHANGE_STATUS], error: null, errorMessage: null };
        }

        if (type === types.SET_SCREEN_BREAKPOINT) {
            return { ...state, screenBreakPoint: action.screenBreakPoint };
        }

    }

    return state;
}
